import { render } from "./MenuUsageAlert.vue?vue&type=template&id=21500c6a&scoped=true&lang=html"
import script from "./MenuUsageAlert.vue?vue&type=script&lang=js"
export * from "./MenuUsageAlert.vue?vue&type=script&lang=js"

import "./MenuUsageAlert.vue?vue&type=style&index=0&id=21500c6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21500c6a"]])

export default __exports__